module.exports = __webpack_public_path__ + "static/img/score-pc-6.42f05546.png";